import EnumSet from 'Services/enumSet'

interface IQuotationStep extends EnumSet {
  serviceType: number
  details: number
  info: number
  deadline: number
  sent: number
}

const QuotationStep = new EnumSet({
  serviceType: { value: 0, description: 'especialidade' },
  details: { value: 1, description: 'detalhes' },
  info: { value: 2, description: 'dados' },
  deadline: { value: 3, description: 'prazo' },
  sent: { value: 4, description: 'enviado' },
}) as IQuotationStep

export default QuotationStep